//节点
import rlBaseData from "./rlBaseData";
import { rlGridData } from "@/rlMxModules/rlDataClass/index";
import store from "@/store";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
// import mxcad from "mxcad";
import mxcad from "mxcad";
const { McDbPoint, McGePoint3d, McDbLine, McDbCircle, McDbText } = mxcad;
import { rlTextData } from "@/rlMxModules/rlDataClass/index";
import {
  addEntityToDrawing,
  getEntityData,
  ptOnLine,
  areLineCollinear,
} from "@/rlMxModules/operate/operateApi";

import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import { calculateArcAngle } from "../operate/GraphicDataCal";

class rlJointData extends rlBaseData {
  constructor() {
    super();
    this.m_pt = null; // 节点坐标
    this.classTypeName = "rlJoint"; // 点
    this.mcDbPoint = new McDbPoint(); //关联的cad节点类
    this.mcDbCircle = null; //关联的cad圆类
    this.mcDbCircleIds = []; //关联的cad圆类id
    this.mcDbId = null; //关联的cad节点类id
    this.HDiff = 0; //上节点高

    this.m_gridIds = new Array(); //节点所在的网格集合
    this.m_cloumId = null; //节点位置的墙柱id
    // this.m_AxisIds = new Array(); //节点所在的轴线集合
    this.m_slabHoleId = null; //节点上的板洞

    this.m_groupName = "rlPointGroup";
    this.points = []; // 点列表
    this.m_TextObj = null;
    this.m_HDiffTextObj = null;
  }

  myClone() {
    let newObj = new rlJointData();
    newObj.m_pt = [...this.m_pt];
    newObj.HDiff = this.HDiff;
    newObj.mcDbPoint.setPosition(this.m_pt[0], this.m_pt[1], this.m_pt[2]);

    //将数据和图形绑定
    newObj.mcDbPoint.setxDataString("Guid", newObj.Guid);
    newObj.mcDbPoint.setxDataString("classTypeName", newObj.classTypeName);
    return newObj;
  }

  initData(obj) {
    super.initData(obj);
    this.m_pt = obj.m_pt;
    this.HDiff = obj.HDiff ? Number(obj.HDiff) : 0;
    if (this.mcDbId) {
      this.mcDbPoint = this.mcDbId.getMcDbEntity();
    }
    this.mcDbPoint.setPosition(this.m_pt[0], this.m_pt[1], this.m_pt[2]);
    //将数据和图形绑定
    this.mcDbPoint.setxDataString("Guid", this.Guid);
    this.mcDbPoint.setxDataString("classTypeName", this.classTypeName);

    if (this.m_cloumId) {
      let objtmp = getEntityData({
        classTypeName: "rlColSeg",
        Guid: this.m_cloumId,
      });
      objtmp.isWasmGeted = false;
      objtmp.draw();
      objtmp.mcDbId = rlAppObj.mxcadObject.drawEntity(objtmp.mcDbPolyline);
    }
  }

  drawCircel() {
    this.mcDbCircleIds = [];
    // 绘制圆
    let circleRadius = 20;
    this.mcDbCircle = new McDbCircle(
      this.m_pt[0],
      this.m_pt[1],
      this.m_pt[2],
      circleRadius
    );

    // 添加圆到画布
    const rId = rlAppObj.mxcadObject.drawEntity(this.mcDbCircle);
    this.mcDbCircleIds.push(rId);

    // 获取圆心和半径
    const [centerX, centerY, centerZ] = this.m_pt;

    // 计算 X 形状的两条线的端点（在圆的边界上）
    const offset = (circleRadius * Math.sqrt(2)) / 2;

    // 创建 X 形状的两条线
    const line1 = new McDbLine(
      centerX - offset,
      centerY - offset,
      centerZ,
      centerX + offset,
      centerY + offset,
      centerZ
    );
    const line2 = new McDbLine(
      centerX - offset,
      centerY + offset,
      centerZ,
      centerX + offset,
      centerY - offset,
      centerZ
    );

    // 添加线到画布
    const lId = rlAppObj.mxcadObject.drawEntity(line1);
    const lId2 = rlAppObj.mxcadObject.drawEntity(line2);
    this.mcDbCircleIds.push(lId, lId2);
  }

  drawHDiff(newHDiff, erase = false) {
    if (this.m_HDiffTextObj) {
      this.m_HDiffTextObj.erase();
    }
    if (erase) {
      return;
    }

    let updateHDiff = false;
    if (newHDiff != null) {
      updateHDiff = this.HDiff != newHDiff;
      if (updateHDiff) {
        this.saveEditRevokeData();
        this.HDiff = newHDiff;
        this.updateThisObj(this, false);
      }
    }

    this.m_HDiffTextObj = new rlTextData();
    this.m_HDiffTextObj.position = new THREE.Vector3(
      this.m_pt[0],
      this.m_pt[1],
      0
    );

    this.m_HDiffTextObj.Text = this.HDiff.toString() + "mm";
    this.m_HDiffTextObj.draw(true);
    this.m_HDiffTextObj.lineObjId = this.m_HDiffTextObj.mcDbId;

    if (updateHDiff) {
      this.updateModelData();
    }
  }

  //上节点高变化，更新相关的模型
  updateModelData() {
    if (this.m_cloumId) {
      let colObj = getEntityData({
        classTypeName: "rlColSeg",
        Guid: this.m_cloumId,
      });
      if (colObj) {
        colObj.saveEditRevokeData();
        colObj.updateThisObj(colObj);
      }
    }

    if (this.m_gridIds) {
      for (let i = 0; i < this.m_gridIds.length; i++) {
        let gridObj = getEntityData({
          classTypeName: "rlGrid",
          Guid: this.m_gridIds[i],
        });
        if (gridObj) {
          if (gridObj.m_beamId) {
            let beamObj = getEntityData({
              classTypeName: "rlBeamSeg",
              Guid: gridObj.m_beamId,
            });
            if (beamObj) {
              beamObj.saveEditRevokeData();
              beamObj.updateThisObj(beamObj);
            }
          }
          if (gridObj.m_wallId) {
            let wallObj = getEntityData({
              classTypeName: "rlWallSeg",
              Guid: gridObj.m_wallId,
            });
            if (wallObj) {
              wallObj.saveEditRevokeData();
              wallObj.updateThisObj(wallObj);
            }
          }
          if (gridObj.m_partitionWallId) {
            let partitionWallObj = getEntityData({
              classTypeName: "rlPartitionWallSeg",
              Guid: gridObj.m_partitionWallId,
            });
            if (partitionWallObj) {
              partitionWallObj.saveEditRevokeData();
              partitionWallObj.updateThisObj(partitionWallObj);
            }
          }
        }
      }
    }
  }

  drawTextTest() {
    return;
    this.m_TextObj = new rlTextData();
    this.m_TextObj.position = new THREE.Vector3(
      this.m_pt[0],
      this.m_pt[1] + 50,
      0
    );
    this.m_TextObj.Text = this.Guid.slice(-5);
    this.m_TextObj.textType = "测试节点";
    this.m_TextObj.draw(true);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    // super.initData(obj);
    this.m_pt = obj.m_pt;
    this.HDiff = obj.HDiff;
    this.mcDbPoint.setPosition(this.m_pt[0], this.m_pt[1], this.m_pt[2]);
    //将数据和图形绑定
    this.mcDbPoint.setxDataString("Guid", this.Guid);
    this.mcDbPoint.setxDataString("classTypeName", this.classTypeName);
  }

  erase() {
    if (store.state.globalData.isReDo) {
    } else {
      //处理关联的柱
      if (this.m_cloumId) {
        let objtmp = getEntityData({
          Guid: this.m_cloumId,
          classTypeName: "rlColSeg",
        }); //rlAppObj.rlMxDrawObject.getMxEntity(this.m_cloumId);
        if (objtmp) {
          return; //存在关联的柱，不能删
          objtmp.erase();
        }
      }

      if (this.m_gridIds) {
        if (this.m_gridIds.length == 2) {
          //判断是否在两个网格共线
          let objtmp1 = getEntityData({
            classTypeName: "rlGrid",
            Guid: this.m_gridIds[0],
          });
          let objtmp2 = getEntityData({
            classTypeName: "rlGrid",
            Guid: this.m_gridIds[1],
          });

          //若共线，合并网格
          if (
            objtmp1 &&
            objtmp2 /*&& objtmp1.m_Axis.Guid === objtmp2.m_Axis.Guid */
          ) {
            let obj1Pt1 = new THREE.Vector3(...objtmp1.m_stJoint.m_pt);
            let obj1Pt2 = new THREE.Vector3(...objtmp1.m_edJoint.m_pt);
            let obj2Pt1 = new THREE.Vector3(...objtmp2.m_stJoint.m_pt);
            let obj2Pt2 = new THREE.Vector3(...objtmp2.m_edJoint.m_pt);
            if (areLineCollinear(obj1Pt1, obj1Pt2, obj2Pt1, obj2Pt2)) {
              //对两段网格的端点（三个顶点）按照从左到右、从下到上的顺序进行排序
              const jointObjs = [
                objtmp1.m_stJoint,
                objtmp1.m_edJoint,
                objtmp2.m_stJoint,
                objtmp2.m_edJoint,
              ];
              if (
                objtmp1.m_centerJoint ||
                (objtmp1.m_Axis && objtmp1.m_Axis.IsMainAxis < 0)
              ) {
                let centerPoint = new THREE.Vector3(
                  objtmp1.centerPoint[0],
                  objtmp1.centerPoint[1],
                  objtmp1.centerPoint[2]
                );
                jointObjs.sort((a, b) => {
                  let aAngle = calculateArcAngle(
                    centerPoint,
                    new THREE.Vector3(...a.m_pt)
                  );
                  let bAngle = calculateArcAngle(
                    centerPoint,
                    new THREE.Vector3(...b.m_pt)
                  );
                  return aAngle - bAngle;
                });
              } else {
                jointObjs.sort((a, b) => {
                  //增加误差判断
                  if (Math.abs(a.m_pt[0] - b.m_pt[0]) > 1e-2)
                    return a.m_pt[0] - b.m_pt[0];
                  else if (Math.abs(a.m_pt[1] - b.m_pt[1]) > 1e-2)
                    return a.m_pt[1] - b.m_pt[1];
                  else return 0;
                });
              }

              if (
                jointObjs[0].Guid == objtmp1.m_stJoint.Guid ||
                jointObjs[0].Guid == objtmp1.m_edJoint.Guid
              ) {
                objtmp1.saveEditRevokeData();
                objtmp1.m_stJoint = jointObjs[0];
                objtmp1.m_edJoint = jointObjs[3];
                objtmp1.updateThisObj(objtmp1, objtmp2);

                objtmp2.erase(true);
              } else {
                objtmp2.saveEditRevokeData();
                objtmp2.m_stJoint = jointObjs[0];
                objtmp2.m_edJoint = jointObjs[3];
                objtmp2.updateThisObj(objtmp2, objtmp1);

                objtmp1.erase(true);
              }
            } else {
              //删除所有网格
              return; //存在关联的网格，不能删
              objtmp1.erase();
              objtmp2.erase();
            }
          }
        } else if (this.m_gridIds.length >= 1) {
          return; //存在关联的网格，不能删
        }
      }
    }

    this.mcDbCircleIds.forEach((item) => {
      item.getMcDbEntity().erase();
    });
    //删除板洞
    if (this.m_slabHoleId) {
      const objtmp = getEntityData({
        classTypeName: "rlSlabHole",
        Guid: this.m_slabHoleId,
      }); // rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);
      if (objtmp) objtmp.erase();
    }
    this.mcDbPoint?.erase();
    this.mcDbCircle?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    super.erase();
    this.m_TextObj?.erase();
  }

  // 数据修改更新
  updateThisObj(obj, reDrawGrid = true) {
    this.initData(obj);
    super.updateThisObj(obj);

    this.mcDbCircleIds.forEach((item) => {
      item.getMcDbEntity().erase();
    });

    this.drawCircel();
    if (reDrawGrid) {
      //更新网格的显示
      this.m_gridIds.forEach((item) => {
        let objtmp = getEntityData({
          classTypeName: "rlGrid",
          Guid: item,
        });
        if (objtmp) {
          objtmp.updateData();
        }
      });
    }

    //更新轴线
    // for (let jj = 0; jj < this.m_AxisIds.length; jj++) {
    //   const item = this.m_AxisIds[jj];

    //   let objAxis = getEntityData({
    //     classTypeName: "rlAxis",
    //     Guid: item,
    //   });

    //   if (
    //     objAxis &&
    //     // objAxis.m_gridIds.length > 1 &&
    //     (this.Guid == objAxis.m_stJoint.Guid ||
    //       this.Guid == objAxis.m_edJoint.Guid)
    //   ) {
    //     let searchJointObj =
    //       this.Guid == objAxis.m_stJoint.Guid
    //         ? objAxis.m_edJoint
    //         : objAxis.m_stJoint;

    //     //判断节点新位置是否终点所在的网格线上，
    //     let stPoint = null;
    //     let edPoint = null;
    //     for (let i = 0; i < searchJointObj.m_gridIds.length; i++) {
    //       const gridId = searchJointObj.m_gridIds[i];
    //       let gridObj = getEntityData({
    //         classTypeName: "rlGrid",
    //         Guid: gridId,
    //       });
    //       if (gridObj.m_Axis.Guid === objAxis.Guid) {
    //         stPoint = new THREE.Vector3(...gridObj.m_stJoint.m_pt);
    //         edPoint = new THREE.Vector3(...gridObj.m_edJoint.m_pt);
    //         break;
    //       }
    //     }

    //     if (!stPoint || !edPoint) continue;

    //     //获取节点上的所有节点
    //     let axisJointData = [];
    //     for (let i = 0; i < objAxis.m_gridIds.length; i++) {
    //       const gridId = objAxis.m_gridIds[i];
    //       let gridObj = getEntityData({
    //         classTypeName: "rlGrid",
    //         Guid: gridId,
    //       });
    //       axisJointData.push({
    //         pt: new THREE.Vector3(...gridObj.m_stJoint.m_pt),
    //         obj: gridObj.m_stJoint,
    //       });
    //       axisJointData.push({
    //         pt: new THREE.Vector3(...gridObj.m_edJoint.m_pt),
    //         obj: gridObj.m_edJoint,
    //       });
    //     }
    //     if (ptOnLine(stPoint, edPoint, new THREE.Vector3(...this.m_pt)) > 0) {
    //       //若节点新位置依旧在轴线上，重新排序轴线上的节点，更新轴线的起点终点
    //     } else {
    //       //若不是，更新轴线起点，
    //       axisJointData = axisJointData.filter(
    //         (item) => item.obj.Guid != this.Guid
    //       );
    //     }

    //     // 按x、y、z坐标分别排序
    //     axisJointData.sort(function (a, b) {
    //       if (a.pt.x !== b.pt.x) return a.pt.x - b.pt.x;
    //       if (a.pt.y !== b.pt.y) return a.pt.y - b.pt.y;
    //       return a.pt.z - b.pt.z;
    //     });
    //     objAxis.saveEditRevokeData();

    //     //取最小、最大的端点
    //     objAxis.m_stJoint = axisJointData[0].obj;
    //     objAxis.m_edJoint = axisJointData[axisJointData.length - 1].obj;

    //     if (
    //       objAxis.m_stJoint.Guid != this.Guid &&
    //       objAxis.m_edJoint.Guid != this.Guid
    //     ) {
    //       jj--;
    //     }

    //     objAxis.updateThisObj(objAxis);
    //   }
    // }

    //测试代码
    this.m_TextObj?.erase();
    this.drawTextTest();
  }

  async transformBy(vecMove) {
    let objJoint = new rlJointData(); //this.myClone();
    let ptNew = new THREE.Vector3(...this.m_pt).add(vecMove).toArray();
    objJoint.initData({ m_pt: ptNew });

    if (this.m_cloumId) {
      objJoint.m_cloumId = this.m_cloumId;
      let objtmp = getEntityData({
        Guid: this.m_cloumId,
        classTypeName: "rlColSeg",
      }); //rlAppObj.rlMxDrawObject.getMxEntity(this.m_cloumId);
      if (objtmp) {
        objtmp.m_JointData = objJoint;
        // objtmp.setNeedUpdateDisplay();
      }

      this.m_cloumId = null;
    }

    //保存点的数据
    let isExist = await addEntityToDrawing(objJoint, false);
    return isExist;
  }

  // 返回图形源数据
  getDataBase() {
    try {
      let data = super.getDataBase();

      //保留两位小数
      data["X"] = Number(this.m_pt[0].toFixed(2));
      data["Y"] = Number(this.m_pt[1].toFixed(2));
      data["Z"] = Number(this.m_pt[2].toFixed(2));
      data["HDiff"] = this.HDiff ? Number(this.HDiff) : 0;
      return data;
    } catch (error) {
      return null;
    }
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    try {
      let data = super.getDrawData();
      data["m_pt"] = this.m_pt;
      data["HDiff"] = this.HDiff;
      //关联数据
      data["m_gridIds"] = this.m_gridIds;
      data["m_cloumId"] = this.m_cloumId;
      // data["m_AxisIds"] = this.m_AxisIds;
      data["m_slabHoleId"] = this.m_slabHoleId;

      return data;
    } catch (error) {
      return null;
    }
  }

  // 画点
  async draw() {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      // 鼠标第一次点击
      getPoint.go((status) => {
        //右键关闭
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0) {
          return;
        }
        // 当前鼠标位置
        this.m_pt = getPoint.value().toArray();
        if (store.state.platBtns.topBtnActive.id !== 101) return;
        this.initData({ m_pt: this.m_pt });
        // rlAppObj.mxcadObject.drawEntity(this.mcDbPoint);
        addEntityToDrawing(this);
        resolve(this);
      });
    });
  }

  // 画点(模数录入)
  async drawPoint(nodeSimulate) {
    return new Promise((resolve, reject) => {
      // 实例化取点对象
      const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
      let endPoint = null;
      fixOrthogonal(false);
      // 鼠标第一次点击
      getPoint.go((status) => {
        if (status === -1) {
          store.commit("platBtns/CHANGE_MOVEBOX", {
            id: store.state.platBtns.topBtnActive.drawId,
            bol: false,
          });
        }
        if (status != 0 || !nodeSimulate) {
          return;
        }
        store.commit("drawModules/setDrawPlay", true);
        fixOrthogonal(true);
        // 当前鼠标位置
        if (store.state.platBtns.topBtnActive.id !== 101) return;
        this.points.push(getPoint.value());
        const PI_HALF = Math.PI / 2;
        getPoint.setUserDraw((currentPoint, pWorldDraw) => {
          fixOrthogonal(true);
          if (this.points.length >= 1) {
            const startPoint = this.points[0];
            endPoint = currentPoint.clone(); // 克隆当前点作为终点
            const distance = startPoint.distanceTo(endPoint); // 计算距离
            const modulusDistance =
              Math.ceil(distance / nodeSimulate) * nodeSimulate; // 将距离调整到模数的最近整数倍

            // 保持方向不变，调整endPoint到模数的最近整数倍距离
            endPoint
              .sub(startPoint)
              .normalize()
              .multiplyScalar(modulusDistance)
              .add(startPoint);

            // 计算两点之间的角度
            let angle = Math.atan2(
              endPoint.y - startPoint.y,
              endPoint.x - startPoint.x
            );
            let angleValue = ((angle * 180) / Math.PI + 360) % 360;
            const value =
              modulusDistance.toFixed(2) +
              "mm" +
              "  " +
              (angleValue === 360 ? 0 : angleValue).toFixed(2) +
              "°";

            // 修正角度在左右侧的显示
            if (angle > PI_HALF || angle < -PI_HALF) {
              angle -= Math.PI;
            }

            // 绘制文本和线条
            const textSize = modulusDistance / 10;
            const midPoint = new THREE.Vector3().lerpVectors(
              startPoint,
              endPoint,
              0.5
            );
            midPoint.y += textSize;
            pWorldDraw.drawText(value, textSize, angle, midPoint);
            pWorldDraw.drawLine(startPoint, endPoint); // 绘制线段，长度为模数的整数倍
          }
        });

        // 鼠标第二次
        getPoint.go((status2) => {
          // 鼠标右键结束绘制
          if (status2 !== 0) {
            return resolve();
          }
          // 最后一个点位置
          this.m_pt = endPoint.toArray();
          this.initData({ m_pt: this.m_pt });
          // rlAppObj.mxcadObject.drawEntity(this.mcDbPoint);
          addEntityToDrawing(this);
          resolve(this);
        });
      });
      store.commit("drawModules/setDrawPlay", false);
    });
  }

  // 画点(参数录入)
  async drawPointByParam(point) {
    return new Promise((resolve, reject) => {
      this.m_pt = [point.x, point.y, point.z];
      this.initData({ m_pt: this.m_pt });
      // rlAppObj.mxcadObject.drawEntity(this.mcDbPoint);
      addEntityToDrawing(this);
      resolve(this);
    });
  }
}
export { rlJointData };
